import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/',
    redirect: '/certification'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于' }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/User.vue'),
    meta: { 
      title: '用户管理',
      requiresAuth: true 
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { 
      title: '登录',
      hideForAuth: true 
    }
  },
  {
    path: '/certification',
    name: 'Certification',
    component: () => import('@/views/Certification.vue'),
    meta: { 
      title: '代理商认证'
    }
  },
  {
    path: '/my-certification',
    name: 'MyCertification',
    component: () => import('@/views/MyCertification.vue'),
    meta: {
      title: '我的认证',
      requiresAuth: true
    }
  },
  {
    path: '/parameter-query',
    name: 'ParameterQuery',
    component: () => import('@/views/ParameterQuery.vue'),
    meta: {
      title: '参数查询',
      requiresAuth: true
    }
  },
  {
    path: '/certification-complete',
    name: 'CertificationComplete',
    component: () => import('@/views/CertificationComplete.vue'),
    meta: { 
      title: '认证提交完成'
    }
  },
  {
    path: '/project-report',
    name: 'ProjectReport',
    component: () => import('@/views/ProjectReport.vue'),
    meta: {
      title: '项目报备',
      requiresAuth: true
    }
  },
  {
    path: '/my-report',
    name: 'MyReport',
    component: () => import('@/views/MyReport.vue'),
    meta: {
      title: '我的报备',
      requiresAuth: true
    }
  },
  {
    path: '/my-report/:reportNo',
    name: 'MyReportDetail',
    component: () => import('@/views/MyReportDetail.vue'),
    meta: {
      title: '项目报备详情',
      requiresAuth: true
    }
  },
  {
    path: '/excellent-representative-application',
    name: 'ExcellentRepresentativeApplication',
    component: () => import('@/views/ExcellentRepresentativeApplication.vue'),
    meta: {
      title: '渠道优秀代表申请',
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '页面未找到' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - JX Vue App`
  }

  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    if (store.getters['user/isLoggedIn']) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } 
  // 如果已登录用户访问登录页，重定向到首页
  else if (to.meta.hideForAuth && store.getters['user/isLoggedIn']) {
    next('/')
  } 
  else {
    next()
  }
})

export default router
